// extracted by mini-css-extract-plugin
export var displayAll = "blog-post-preview-list-module--displayAll--45f35";
export var grid = "blog-post-preview-list-module--grid--2fb61";
export var gridAsList = "blog-post-preview-list-module--gridAsList--f422a";
export var headline = "blog-post-preview-list-module--headline--4bcbf";
export var recentPost = "blog-post-preview-list-module--recentPost--b5de3";
export var root = "blog-post-preview-list-module--root--3187f";
export var small = "blog-post-preview-list-module--small--aa1dc";